import { mapActions, mapMutations, mapState } from 'vuex'
import { ErrorHelper } from '@/helpers/ErrorHelper'
import { SelectedSiteIdMixin } from './SelectedSiteIdMixin'
import { ResourceCacheMixin } from './ResourceCacheMixin'

export const OpenSlotCacheMixin = {
  mixins: [SelectedSiteIdMixin, ResourceCacheMixin],
  data () {
    return {
      error: ''
    }
  },
  computed: {
    ...mapState('OpenSlots', [
      'openSlots',
      'loadingOpenSlots'
    ]),
    ...mapState('BookingUpload', [
      'selectedPets',
      'openSlotBooking'
    ]),
    ...mapState('Subscription', [
      'subscription',
      'fetchedSubscription'
    ]),
    openSlotFeatureAllowed () {
      return !!this.subscription && !!this.subscription.feature && !!this.subscription.feature.openSlot
    },
    postId () {
      return this.$route.query.postId || this.$route.query.postid || ''
    },
    availableResourceOpenSlots () {
      const unhiddenResourceIds = new Set(this.unhiddenResources.map(r => r.id))
      return this.openSlots.filter(s => unhiddenResourceIds.has(s.resourceId))
    },
    isOpenSlotBooking () {
      return !!this.postId && this.availableResourceOpenSlots.length > 0
    },
    availableSlotCount () {
      return this.availableResourceOpenSlots.length
    },
    openSlotDurationMinutes () {
      return this.openSlots.length > 0 ? this.openSlots[0].durationMinutes : 0
    },
    openSlotStartUtc () {
      return this.openSlots.length > 0 ? this.openSlots[0].startUtc : null
    }
  },
  watch: {
    openSlotDurationMinutes (value) {
      this.setOpenSlotDuration(value)
    },
    postId () {
      this.refreshOpenSlots()
    },
    selectedSiteId () {
      this.refreshOpenSlots()
    },
    fetchedSubscription () {
      this.refreshOpenSlots()
    }
  },
  methods: {
    ...mapMutations('OpenSlots', [
      'resetOpenSlots'
    ]),
    ...mapMutations('BookingUpload', [
      'setOpenSlotBooking',
      'setOpenSlotDuration',
      'setStartUtc',
      'setResourceIds',
      'setOpenSlotId'
    ]),
    ...mapActions('OpenSlots', [
      'fetchOpenSlots'
    ]),
    refreshOpenSlots () {
      if (!this.postId || !this.selectedSiteId) {
        this.resetOpenSlots()
        return
      }
      this.tryGetOpenSlots()
    },
    applyOpenSlotData () {
      if (!this.isOpenSlotBooking) return
      this.setStartUtc(this.openSlotStartUtc)
      this.setOpenSlotDuration(this.openSlotDurationMinutes)
      this.setOpenSlotBooking(true)
      const resourceIds = this.selectedPets.map((_, i) =>
        this.openSlots[i] ? this.openSlots[i].resourceId : this.openSlots[0].resourceId
      )
      this.setResourceIds(resourceIds)
      this.selectedPets.forEach((pet, i) => {
        const slot = this.openSlots[i]
        if (slot) {
          this.setOpenSlotId({ petId: pet.id, openSlotId: slot.id })
        }
      })
    },
    tryGetOpenSlots () {
      if (this.loadingOpenSlots || !this.openSlotFeatureAllowed) return
      this.error = ''
      this.fetchOpenSlots({ siteId: this.selectedSiteId, postId: this.postId })
        .then(() => { this.applyOpenSlotData() })
        .catch(error => { this.error = ErrorHelper.getError(error) })
    }
  },
  created () {
    this.refreshOpenSlots()
  }
}
